import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RequestMapperService} from "../request-mapper.service";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {VerifyEmailComponent} from "./verify-email/verify-email.component";
import {EmailVerficationStatusComponent} from "./email-verfication-status/email-verfication-status.component";
import {AuthenticationComponent} from "./authentication/authentication.component";


const routes: Routes = [
	{
		path: RequestMapperService.BASE_RELATIVE_URL,
		component: AuthenticationComponent
	},
	{
		path: RequestMapperService.FORGOT_PASSWORD,
		component: ForgotPasswordComponent
	},
	{
		path: RequestMapperService.FORGOT_PASSWORD + '/:forgotPasswordToken',
		component: ForgotPasswordComponent
	},
	{
		path: RequestMapperService.VERIFY_EMAIL,
		component: VerifyEmailComponent
	},
	{
		path: RequestMapperService.VERIFY_EMAIL + '/:verifyEmailToken',
		component: EmailVerficationStatusComponent
	},
	{
		path: RequestMapperService.LOGIN,
		pathMatch: "full",
		redirectTo: RequestMapperService.BASE_RELATIVE_URL
	},
	{
		path: RequestMapperService.SIGNUP,
		pathMatch: "full",
		redirectTo: RequestMapperService.BASE_RELATIVE_URL
	}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
